import type * as React from 'react';
import { Text } from '@dx-ui/global-ui-prism';

export type IProps = {
  resortFeeText: string;
};

const ResortFeeDetails: React.FC<React.PropsWithChildren<IProps>> = ({ resortFeeText }) => {
  return resortFeeText ? (
    <div className="resort-fee-desc mb-6 mt-4 bg-surface-info px-6 py-4" data-testid="fee-wrapper">
      <Text>{resortFeeText}</Text>
    </div>
  ) : null;
};

export default ResortFeeDetails;
